import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/pages/blank-page",
    component: lazy(() => import("../../view/pages/blank")),
    layout: "VerticalLayout",
  },
  {
    path: "/pages/error-page",
    component: lazy(() => import("../../view/pages/error")),
    layout: "FullLayout",
  },
  {
    path: "/login",
    component: lazy(() => import("../../view/Login")),
    layout: "FullLayout",
  },
  {
    path: "/forgotpassword",
    component: lazy(() => import("../../view/Login/Password/ForgotPassword")),
    layout: "FullLayout",
  },
  {
    path: "/resetpassword",
    component: lazy(() => import("../../view/Login/Password/ResetPassword")),
    layout: "FullLayout",
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../../view/Dashboard")),
    layout: "VerticalLayout",
  },
  {
    path: "/expenseclaim",
    component: lazy(() => import("../../view/ExpenseClaim")),
    layout: "VerticalLayout",
  },
  {
    path: "/newexpense",
    component: lazy(() => import("../../view/NewExpense")),
    layout: "VerticalLayout",
  },
  {
    path: "/employeeadvance",
    component: lazy(() => import("../../view/EmployeeAdvance")),
    layout: "VerticalLayout",
  },
  {
    path: "/traveladvance",
    component: lazy(() => import("../../view/TravelAdvance")),
    layout: "VerticalLayout",
  },
  {
    path: "/approvals",
    component: lazy(() => import("../../view/Approvals")),
    layout: "VerticalLayout",
  },
  {
    path: "/settings",
    component: lazy(() => import("../../view/Settings")),
    layout: "VerticalLayout",
  },
  {
    path: "/emailcredential",
    component: lazy(() => import("../../view/EmailCredentials")),
    layout: "VerticalLayout",
  },
  {
    path: "/emailcontent",
    component: lazy(() => import("../../view/EmailContent")),
    layout: "VerticalLayout",
  },
  {
    path: "/failedapprovals",
    component: lazy(() => import("../../view/FailedApprovals")),
    layout: "VerticalLayout",
  },
  {
    path: "/reportlist",
    component: lazy(() => import("../../view/ReportsList")),
    layout: "VerticalLayout",
  },
  {
    path: "/report",
    component: lazy(() => import("../../view/Report")),
    layout: "VerticalLayout",
  },
  {
    path: "/allsettings",
    component: lazy(() => import("../../view/Settings/AllSettings")),
    layout: "VerticalLayout",
  },
  {
    path: "/allsettings",
    component: lazy(() => import("../../view/Settings/AllSettings")),
    layout: "VerticalLayout",
  },
  {
    path: "/settlement",
    component: lazy(() => import("../../view/Settlement")),
    layout: "VerticalLayout",
  },
  {
    path: "/settlementlist",
    component: lazy(() => import("../../view/SettlementList")),
    layout: "VerticalLayout",
  },
  {
    path: "/advancerefund",
    component: lazy(() => import("../../view/AdvanceRefund")),
    layout: "VerticalLayout",
  },
  {
    path: "/refundlist",
    component: lazy(() => import("../../view/RefundList")),
    layout: "VerticalLayout",
  },
  {
    path: "/trips",
    component: lazy(() => import("../../view/Trips")),
    layout: "VerticalLayout",
  },
  {
    path: "/NewTrips",
    component: lazy(() => import("../../view/NewTrips")),
    layout: "VerticalLayout",
  },
  {
    path: "/TripsDetails",
    component: lazy(() => import("../../view/TripsDetails")),
    layout: "VerticalLayout",
  },
  {
    path: "/MyProfile",
    component: lazy(() => import("../../view/UserMaster")),
    layout: "VerticalLayout",
  },
];

export default PagesRoutes;